// Ready-to-insert Outlook/MSO fallback snippets for the HTML editor. Outlook (Word engine)
// ignores modern CSS, so these conditional-comment blocks + VML give reliable fallbacks.

export interface Snippet {
  label: string
  title: string
  code: string
}

export const outlookSnippets: Snippet[] = [
  {
    label: 'MSO comment',
    title: 'Outlook-only conditional comment block',
    code: `<!--[if mso]>\n<!-- Outlook-only markup here -->\n<![endif]-->\n`,
  },
  {
    label: 'Non-Outlook',
    title: 'Everything-except-Outlook block',
    code: `<!--[if !mso]><!-->\n<!-- Shown everywhere except Outlook -->\n<!--<![endif]-->\n`,
  },
  {
    label: 'Ghost table',
    title: 'Outlook fixed-width centering container (ghost table)',
    code: `<!--[if mso]>\n<table role="presentation" align="center" border="0" cellpadding="0" cellspacing="0" width="600"><tr><td>\n<![endif]-->\n<div style="max-width:600px;margin:0 auto;">\n  <!-- content -->\n</div>\n<!--[if mso]>\n</td></tr></table>\n<![endif]-->\n`,
  },
  {
    label: 'VML button',
    title: 'Bulletproof rounded button with Outlook VML fallback',
    code: `<div>\n  <!--[if mso]>\n  <v:roundrect xmlns:v="urn:schemas-microsoft-com:vml" xmlns:w="urn:schemas-microsoft-com:office:word" href="https://example.com" style="height:44px;v-text-anchor:middle;width:220px;" arcsize="12%" strokecolor="#151e6d" fillcolor="#151e6d">\n    <w:anchorlock/>\n    <center style="color:#ffffff;font-family:Arial,sans-serif;font-size:15px;font-weight:bold;">Shop now</center>\n  </v:roundrect>\n  <![endif]-->\n  <!--[if !mso]><!-->\n  <a href="https://example.com" style="display:inline-block;background:#151e6d;color:#ffffff;font-family:Arial,sans-serif;font-size:15px;font-weight:bold;text-decoration:none;padding:13px 26px;border-radius:6px;">Shop now</a>\n  <!--<![endif]-->\n</div>\n`,
  },
]
